/**
 * Add page/section specific features here.
 *
 * To load a feature on more than one page,
 * separate each class name with a comma and a space
 * @type {Object}
 */

import {initMethods} from './utilities';

export default {
    styleguide: {
        default: '[data-action="Styleguide-Show"]',
        init: function() {
            return import(/* webpackChunkName: "page-styleguide" */ '../styleguide').then(function(Styleguide) {
                return Styleguide.default();
            });
        }
    },
    search: {
        default: '[data-action="Search-Show"]',
        init: function() {
            return import(/* webpackChunkName: "page-search" */ '../search').then(function(Search) {
                return initMethods(Search.default);
            });
        }
    },
    product: {
        default: '[data-action="Product-Show"]',
        init: function() {
            return import(/* webpackChunkName: "page-product" */ '../product').then(function(Product) {
                return initMethods(Product.default);
            });
        }
    },
    cart: {
        default: '[data-action="Cart-Show"]',
        init: function() {
            return import(/* webpackChunkName: "page-cart" */ '../cart').then(function(Cart) {
                return initMethods(Cart.default);
            });
        }
    },
    account: {
        default: '[data-action="Address-EditAddress"], [data-action="Address-AddAddress"]',
        init: function() {
            return import(/* webpackChunkName: "page-address" */ '../account').then(function(Account) {
                return initMethods(Account.default);
            });
        }
    },
    checkout: {
        default: '[data-action="Checkout-Begin"]',
        init: function() {
            return import(/* webpackChunkName: "page-checkout" */ '../checkout').then(function(Checkout) {
                return initMethods(Checkout.default);
            });
        }
    },
    wishlist: {
        default: '[data-action="Wishlist-Show"], [data-action="Wishlist-ShowOthers"], [data-action="Account-Show"]',
        init: function() {
            return import(/* webpackChunkName: "page-wishlist" */ '../wishlist').then(function(Wishlist) {
                return initMethods(Wishlist.default);
            });
        }
    },
    orderHistory: {
        default: '[data-action="Order-History"]',
        init: function() {
            return import(/* webpackChunkName: "page-order-history" */ '../order/history').then(function(OrderHistory) {
                return initMethods(OrderHistory.default);
            });
        }
    },
    pageDesigner: {
        default: '[data-page-designer="Edit-Mode"]',
        init: function() {
            return import(/* webpackChunkName: "page-page-designer-edit" */ '../pageDesigner').then(function(PageDesigner) {
                return initMethods(PageDesigner.default);
            });
        }
    },
    storesAssignmentPage: {
        default: '[data-action="Stores-Assignment"]',
        init: function() {
            return import(/* webpackChunkName: "page-stores-assignment" */ '../account/storesAssignment').then(function(StoresAssignment) {
                return initMethods(StoresAssignment.default);
            });
        }
    },
    contact: {
        default: '[data-action="ContactUs-Landing"]',
        init: function() {
            return import(/* webpackChunkName: "page-contact" */ '../contact').then(function(Contact) {
                return Contact.default();
            });
        }
    },
    emailUnsubscribe: {
        default: '[data-action="EmailSubscribe-UnsubscriptionPage"]',
        init: function() {
            return import(/* webpackChunkName: "page-email-unsubscription" */ '../email').then(function(EmailUnsubscribe) {
                return initMethods(EmailUnsubscribe.default);
            });
        }
    },
    orderDetails: {
        default: '[data-action="Order-Details"], [data-action="Order-Track"]',
        init: function() {
            return import(/* webpackChunkName: "page-order-details" */ '../order/details').then(function(OrderDetails) {
                return initMethods(OrderDetails.default);
            });
        }
    },
    paymentLink: {
        default: '[data-action="PaymentLinkCheckout-Payment"]',
        init: function() {
            return import(/* webpackChunkName: "page-PaymentLinkCheckout" */ '../PaymentLinkCheckout').then(function(PaymentLink) {
                return initMethods(PaymentLink.default);
            });
        }
    },
    profileEditCAPI: {
        default: '[data-action="Account-EditProfile"]',
        init: function() {
            return import(/* webpackChunkName: "profile-edit-capi" */ '../account/profileEditCAPI').then(function(profileEditCAPI) {
                return profileEditCAPI.default();
            });
        }
    }
};
